import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";

function Header() {
  // pc
  const [isHover, setIsHover] = useState(false);

  const handleover = () => {
    setIsHover(true);
  };

  const handleout = () => {
    setIsHover(false);
  };

  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  // mobile
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isClick, setIsClick] = useState(false);
  const [openBtn, setOpenBtn] = useState([false, false, false, false]);

  const onOpenBtn = (idx, doOpen) => {
    const copy = [...openBtn];
    // eslint-disable-next-line array-callback-return
    copy.map((e, i) => {
      copy[i] = false;
    });
    copy[idx] = doOpen;
    setOpenBtn(copy);
  };

  const onClick = () => {
    setIsClick(!isClick);
  };

  const onLogoClick = () => {
    setIsClick(false);
  };

  //스크롤 모바일
  const updateScroll = () => {
    setScrollPosition(window.scrollY || document.documentElement.scrollTop);
  };
  useEffect(() => {
    window.addEventListener("scroll", updateScroll);
  }, []);

  //버튼 클릭시 이동(임시)
  const gnbList = document.getElementsByClassName("gnb-list")[0];
  const onOpengnb = (e) => {
    const targetValue = e.target;

    classRemove(gnbList?.children);
    targetValue.parentNode.classList.add("on");
  };

  //on 클래스 삭제
  function classRemove(arr) {
    for (let i = 0; i < arr?.length; i++) {
      arr[i].classList.remove("on");
    }
  }

  return (
    <>
      {pc ? (
        <header
          className={
            (scrollPosition > 100 ? "header scroll" : "header") +
            (isHover ? " on" : "")
          }
        >
          <div className="inner">
            <h1>
              <Link className="logo" to="/"></Link>
            </h1>
            <ul
              className="gnb-list"
              onMouseOver={handleover}
              onMouseOut={handleout}
            >
              <li className="gnb-item">
                <div className="gnb-hidden">
                  <Link to="/about/overview" className="gnb-link">
                    회사 소개<span className="line"></span>
                  </Link>
                </div>
                <ul className="gnb-sub-list">
                  <li className="gnb-sub-item">
                    <Link to="/about/overview" className="gnb-link">
                      회사 소개
                    </Link>
                    <span className="line"></span>
                  </li>
                  <li className="gnb-sub-item">
                    <Link to="/about/record" className="gnb-link">
                      수행 실적
                    </Link>
                    <span className="line"></span>
                  </li>
                  <li className="gnb-sub-item">
                    <Link to="/about/customer" className="gnb-link">
                      고객사
                    </Link>
                    <span className="line"></span>
                  </li>
                  <li className="gnb-sub-item">
                    <Link to="/about/map" className="gnb-link">
                      오시는 길
                    </Link>
                    <span className="line"></span>
                  </li>
                </ul>
              </li>
              <li className="gnb-item">
                <div className="gnb-hidden">
                  <Link to="/business/digitaltwin" className="gnb-link">
                    사업 분야<span className="line"></span>
                  </Link>
                </div>
                <ul className="gnb-sub-list gnb-align">
                  <li className="gnb-sub-item">
                    <Link to="/business/digitaltwin" className="gnb-link">
                      Digital Twin
                    </Link>
                    <span className="line"></span>
                  </li>
                  <li className="gnb-sub-item">
                    <Link to="/business/geo-iot" className="gnb-link">
                      Geo-IoT
                    </Link>
                    <span className="line"></span>
                  </li>
                  <li className="gnb-sub-item">
                    <Link to="/business/gis" className="gnb-link">
                      GIS
                    </Link>
                    <span className="line"></span>
                  </li>
                  <li className="gnb-sub-item">
                    <Link to="/business/ai" className="gnb-link">
                      AI
                    </Link>
                    <span className="line"></span>
                  </li>
                </ul>
              </li>
              <li className="gnb-item">
                <div className="gnb-hidden">
                  <Link to="/ditap/overview" className="gnb-link">
                    솔루션<span className="line"></span>
                  </Link>
                </div>
                <ul className="gnb-sub-list">
                  <li className="gnb-sub-item">
                    <Link to="/ditap/overview" className="gnb-link">
                      DiTAP
                    </Link>
                    <span className="line"></span>
                  </li>
                  <li className="gnb-sub-item">
                    <Link to="/ditap/ditapjs" className="gnb-link">
                      DiTAP JS
                    </Link>
                    <span className="line"></span>
                  </li>
                  <li className="gnb-sub-item">
                    <Link to="/ditap/ditapforunity" className="gnb-link">
                      DiTAP for Unity
                    </Link>
                    <span className="line"></span>
                  </li>
                  <li className="gnb-sub-item">
                    <Link to="/ditap/ditapbuilder" className="gnb-link">
                      DiTAP Builder
                    </Link>
                    <span className="line"></span>
                  </li>
                </ul>
              </li>
              <li className="gnb-item">
                <div className="gnb-hidden">
                  <Link to="/promotion/news" className="gnb-link">
                    홍보 센터<span className="line"></span>
                  </Link>
                </div>
                <ul className="gnb-sub-list">
                  <li className="gnb-sub-item">
                    <Link to="/promotion/news" className="gnb-link">
                      새소식
                    </Link>
                    <span className="line"></span>
                  </li>
                  <li className="gnb-sub-item">
                    <Link to="/promotion/notice" className="gnb-link">
                      공지사항
                    </Link>
                    <span className="line"></span>
                  </li>
                </ul>
              </li>
              <li className="gnb-item">
                <div className="gnb-hidden">
                  <Link to="/recruit/overview" className="gnb-link">
                    인재 채용<span className="line"></span>
                  </Link>
                </div>
                <ul className="gnb-sub-list">
                  <li className="gnb-sub-item">
                    <Link to="/recruit/overview" className="gnb-link">
                      인재 채용
                    </Link>
                    <span className="line"></span>
                  </li>
                  <li className="gnb-sub-item">
                    <Link to="/recruit/jobposition" className="gnb-link">
                      채용 공고
                    </Link>
                    <span className="line"></span>
                  </li>
                </ul>
              </li>
            </ul>
            <button
              className="solution-link"
              onClick={() => window.open("https://ditap.heliosen.co.kr/")}
            >
              DiTAP 솔루션
            </button>
          </div>
          <p className="header-back-hover">
            <span className="header-line-hover"></span>
          </p>
        </header>
      ) : (
        <header
          className={
            (scrollPosition > 100 ? "header scroll" : "header") +
            (isClick ? " mobile-header on" : " ")
          }
        >
          <h1 className="logo-headline" onClick={onLogoClick}>
            <Link className="logo" to="/"></Link>
          </h1>
          <p className="hamburger-btn" onClick={onClick}></p>
          <div
            className={isClick ? "mobile-gnb-slider on" : "mobile-gnb-slider"}
          >
            <ul className="gnb-list" onClick={onOpengnb}>
              <li
                onClick={() => {
                  onOpenBtn(0, !openBtn[0]);
                }}
                className={openBtn[0] ? "gnb-item on" : "gnb-item"}
              >
                <Link to="/about/overview" className="gnb-link">
                  회사 소개
                </Link>
                <ul className="gnb-sub-list">
                  <li className="gnb-sub-item" onClick={onClick}>
                    <Link to="/about/overview" className="gnb-link">
                      회사 소개
                    </Link>
                  </li>
                  <li className="gnb-sub-item" onClick={onClick}>
                    <Link to="/about/record" className="gnb-link">
                      수행 실적
                    </Link>
                  </li>
                  <li className="gnb-sub-item" onClick={onClick}>
                    <Link to="/about/customer" className="gnb-link">
                      고객사
                    </Link>
                  </li>
                  <li className="gnb-sub-item" onClick={onClick}>
                    <Link to="/about/map" className="gnb-link">
                      오시는 길
                    </Link>
                  </li>
                </ul>
              </li>
              <li
                onClick={() => {
                  onOpenBtn(1, !openBtn[1]);
                }}
                className={openBtn[1] ? "gnb-item on" : "gnb-item"}
              >
                <Link to="/business/digitaltwin" className="gnb-link">
                  사업 분야
                </Link>
                <ul className="gnb-sub-list gnb-align">
                  <li className="gnb-sub-item" onClick={onClick}>
                    <Link to="/business/digitaltwin" className="gnb-link">
                      Digital Twin
                    </Link>
                  </li>
                  <li className="gnb-sub-item" onClick={onClick}>
                    <Link to="/business/geo-iot" className="gnb-link">
                      Geo-IoT
                    </Link>
                  </li>
                  <li className="gnb-sub-item" onClick={onClick}>
                    <Link to="/business/gis" className="gnb-link">
                      GIS
                    </Link>
                  </li>
                  <li className="gnb-sub-item" onClick={onClick}>
                    <Link to="/business/ai" className="gnb-link">
                      AI
                    </Link>
                  </li>
                </ul>
              </li>
              <li
                onClick={() => {
                  onOpenBtn(2, !openBtn[2]);
                }}
                className={openBtn[2] ? "gnb-item on" : "gnb-item"}
              >
                <Link to="/ditap/overview" className="gnb-link">
                  솔루션
                </Link>
                <ul className="gnb-sub-list" onClick={onClick}>
                  <li className="gnb-sub-item">
                    <Link to="/ditap/overview" className="gnb-link">
                      DiTAP
                    </Link>
                  </li>
                  <li className="gnb-sub-item" onClick={onClick}>
                    <Link to="/ditap/ditapjs" className="gnb-link">
                      DiTAP JS
                    </Link>
                  </li>
                  <li className="gnb-sub-item" onClick={onClick}>
                    <Link to="/ditap/ditapforunity" className="gnb-link">
                      DiTAP for Unity
                    </Link>
                  </li>
                  <li className="gnb-sub-item" onClick={onClick}>
                    <Link to="/ditap/ditapbuilder" className="gnb-link">
                      DiTAP Builder
                    </Link>
                  </li>
                </ul>
              </li>
              <li
                onClick={() => {
                  onOpenBtn(3, !openBtn[3]);
                }}
                className={openBtn[3] ? "gnb-item on" : "gnb-item"}
              >
                <Link to="/promotion/news" className="gnb-link">
                  홍보 센터
                </Link>
                <ul className="gnb-sub-list">
                  <li className="gnb-sub-item" onClick={onClick}>
                    <Link to="/promotion/news" className="gnb-link">
                      새소식
                    </Link>
                  </li>
                  <li className="gnb-sub-item" onClick={onClick}>
                    <Link to="/promotion/notice" className="gnb-link">
                      공지사항
                    </Link>
                  </li>
                </ul>
              </li>
              <li
                onClick={() => {
                  onOpenBtn(4, !openBtn[4]);
                }}
                className={openBtn[4] ? "gnb-item on" : "gnb-item"}
              >
                <Link to="/recruit/overview" className="gnb-link">
                  인재 채용
                </Link>
                <ul className="gnb-sub-list">
                  <li className="gnb-sub-item" onClick={onClick}>
                    <Link to="/recruit/overview" className="gnb-link">
                      인재 채용
                    </Link>
                  </li>
                  <li className="gnb-sub-item" onClick={onClick}>
                    <Link to="/recruit/jobposition" className="gnb-link">
                      채용 공고
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
            <div className="mobile-gnb-footer">
              <button
                className="footer-youtube-btn"
                onClick={() => window.open("https://youtube.com/@heliosen4024")}
              >
                <span className="footer-youtube-btn-title">회사 소개 영상</span>
                <span className="footer-youtube-btn-img"></span>
              </button>
              <button
                className="solution-link"
                onClick={() => window.open("https://ditap.heliosen.co.kr/")}
              >
                DiTAP 솔루션
              </button>
            </div>
          </div>
        </header>
      )}
    </>
  );
}

export default Header;
